import {
   CUSTOMER_PORTAL_BASE_URL_PREFIX,
   COMMON_BASE_URL_PREFIX
} from '@flowwai-frontend/shared/constants'

export const APP_TERMS_OF_USE_LINK = `https://buildnow.telangana.gov.in/terms-and-conditions`

export const APP_PRIVACY_STATEMENT_LINK = `https://buildnow.telangana.gov.in/privacy-policy`

export const DEFAULT_CHAT_HISTORY_LENGTH = 3

export const DEFAULT_CHAT_HISTORY_TITLE_TRUNCATE_LINES = 5

export const HELP_ANY_TIME_IMG_URL = `${COMMON_BASE_URL_PREFIX}/images/ai-chart-female-icon.png`

export enum MenuOptionEnum {
   ChatHistory = 'CHAT_HISTORY',
   NewChat = 'NEW_CHAT'
}

export const CHAT_MESSAGES_CONTAINER_ID = 'CHAT_MESSAGES_CONTAINER_ID'
